import { RollingNumber } from './RollingNumber';

interface FmvOnlyProps {
  fmv: number;
  /** Defer the inline odometer until the block is on screen —
   *  see `RollingNumber.start`. */
  roll: boolean;
  /** Returning view — render the FMV value as static text with no
   *  roll. Forwarded to the inner `RollingNumber`. */
  instant?: boolean;
}

/**
 * Fallback two-line block used when profit is zero or negative.
 * Small caption "Fair Market Value" sitting above the big FMV
 * amount — same typography as PROFIT but a single colour.
 */
export function FmvOnly({ fmv, roll, instant = false }: FmvOnlyProps) {
  return (
    <div className="flex flex-col items-center">
      <span
        data-co-component="WinnerStepFMV"
        style={{
          color: 'var(--co-WinnerStepFMV-color, rgba(255,255,255,0.60))',
          fontFamily:
            'var(--co-WinnerStepFMV-font, "Inter"), Inter, sans-serif',
          fontSize: 'var(--co-WinnerStepFMV-size, 14px)',
          lineHeight: '22px',
        }}
      >
        Fair Market Value
      </span>
      <span
        data-co-component="WinnerStepProfit"
        className="font-bold tracking-[-0.6px]"
        style={{
          color: 'var(--co-WinnerStepProfit-labelColor, #FFFFFF)',
          fontFamily:
            'var(--co-WinnerStepProfit-font, "Inter"), Inter, sans-serif',
          fontSize: 'var(--co-WinnerStepProfit-size, 44px)',
          lineHeight: '56px',
        }}
      >
        $<RollingNumber value={fmv} start={roll} instant={instant} />
      </span>
    </div>
  );
}
